module.exports = __webpack_public_path__ + "img/B20-20190415_06.8fb43be9.jpg";